import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { UserService } from '../../../../shared/services/user.service';
import { Router } from '@angular/router';
import { CompanyService } from '../../../services/company.service';

@Component({
  selector: 'app-setup-bar',
  templateUrl: './setup-bar.component.html',
  styleUrls: ['./setup-bar.component.scss']
})
export class SetupBarComponent implements OnInit {
  @Input() next: string;
  @Input() previous: string;
  @Input() nextEnabled: boolean;
  @Input() orgId: number;
  @Input() errorMsg: string = '';
  @Output() error: EventEmitter<string> = new EventEmitter();
  name: string = '';

  constructor(private UserService: UserService, private router: Router, private CompanyService: CompanyService) { }

  ngOnInit() {
    this.getUserInfo();
  }

  getUserInfo() {
    if (this.UserService.currentUser === undefined) {
      this.UserService
        .getUserInfo()
        .subscribe(
        user => {
          this.name = JSON.parse(user.user).first_name;
        },
        err => {
          if (err.status == 401) {
            localStorage.clear();
            this.router.navigate(['/']);
          }
        });
    } else {
      this.name = this.UserService.currentUser.first_name;
    }
  }

  showError() {
    this.error.emit(this.errorMsg);
  }
}



// WEBPACK FOOTER //
// ./src/app/onboarding/components/company-setup/setup-bar/setup-bar.component.ts